/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../../variables';
@use '../../../../mixins';

#card-patient-data {
  .patient-title-content {
    display: flex;
    gap: variables.$margin-xlarge;
    align-items: flex-start;
    margin: variables.$padding-medium;

    .privately-insured {
      .MuiTypography-root {
        font-size: 15px;
        line-height: 1.2;
      }

      .MuiCheckbox-root {
        padding-top: 0;
        padding-bottom: 0;
      }

      svg {
        margin-top: -3px;
        margin-bottom: -3px;
      }
    }
  }

  .patient-data-wireframe {
    @include mixins.page-grid-basics;
    margin-top: 0;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-template-rows: 1fr 1fr;
    grid-template-areas:
      '. . . .'
      '. . . .';

    .patient-data-location {
      @include mixins.page-grid-basics;
      grid-template-columns: 1fr 1fr 1fr;
      grid-template-areas: '. city city';
      margin: 0;
      * {
        margin: 0;
      }

      .patient-data-city {
        grid-area: city;
      }
    }

    .insurance-data-location {
      @include mixins.page-grid-basics;
      grid-template-columns: 1fr 1fr;
      grid-template-areas: '. .';
      margin: 0;
      * {
        margin: 0;
      }
    }
  }
}
